import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Kit de Presupuestación Profesional',
  desc: 'Plantillas listas para cotizar trabajos, calcular materiales y cerrar ventas sin dudar.',
  value: '8.990',
  color: 'bg-slate-700'
}, {
  num: '02',
  title: 'Checklist del Técnico Prolijo',
  desc: 'Listas de verificación para cada tipo de trabajo. Las 12 fallas más comunes y cómo evitarlas.',
  value: '7.990',
  color: 'bg-slate-800'
}, {
  num: '03',
  title: 'Guía para Armar tu Primer Taller',
  desc: 'Herramientas mínimas para arrancar, dónde comprar barato y cómo organizarte desde el primer día.',
  value: '5.990',
  color: 'bg-slate-900'
}, {
  num: 'AUTO',
  title: '+10 Manuales Técnicos de Vehículos',
  desc: 'Diagramas eléctricos, tablas de presión y procedimientos para los modelos más comunes en Argentina.',
  value: '12.990',
  color: 'bg-brand-primary'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-brand-dark text-white" data-id="element-20">
      <div className="max-w-6xl mx-auto" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <h2 className="text-4xl md:text-5xl font-black text-brand-primary mb-6 uppercase tracking-tight" data-id="element-23">
            🎁 Bonos incluidos — sin costo extra
          </h2>
          <div className="inline-block bg-brand-green text-white text-xl font-black px-8 py-3 rounded-full animate-pulse-fast shadow-[0_0_20px_rgba(16,185,129,0.5)]" data-id="element-24">
            GRATIS con tu compra hoy
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-25">
          {bonuses.map((b, i) => <div key={i} className="bg-slate-800 rounded-2xl overflow-hidden border border-slate-700 shadow-xl flex flex-col h-full" data-id="element-26">
              <div className={`${b.color} p-4 py-8 flex flex-col items-center justify-center text-center relative`} data-id="element-27">
                <div className="absolute top-2 left-2 bg-white text-slate-900 font-black text-sm px-2 py-1 rounded-lg shadow-sm" data-id="element-28">
                  {b.num}
                </div>
                <h3 className="text-xl md:text-2xl font-black text-white leading-tight drop-shadow-md" data-id="element-29">
                  {b.num === 'AUTO' ? '🚗 BONO' : `BONO ${parseInt(b.num)}`}
                </h3>
              </div>

              <div className="p-6 flex flex-col flex-grow" data-id="element-30">
                <h5 className="text-xl font-bold mb-3 text-brand-secondary" data-id="element-31">
                  {b.title}
                </h5>
                <p className="text-gray-300 text-base mb-6 flex-grow" data-id="element-32">
                  {b.desc}
                </p>

                <div className="mt-auto pt-4 border-t border-slate-700 flex justify-between items-center" data-id="element-33">
                  <div className="text-gray-400 font-medium text-sm" data-id="element-34">
                    Valor: <span className="line-through" data-id="element-35">${b.value}</span>
                  </div>
                  <div className="text-orange-500 font-black text-xl" data-id="element-36">
                    GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* Value Summary Table */}
        <div className="bg-slate-800 border-2 border-brand-primary rounded-3xl p-8 md:p-12 max-w-3xl mx-auto shadow-2xl" data-id="element-37">
          <h3 className="text-3xl font-black text-center mb-8" data-id="element-38">
            💰 Lo que estás recibiendo hoy
          </h3>

          <div className="space-y-4 mb-8" data-id="element-39">
            <div className="flex justify-between text-lg md:text-xl text-gray-300 border-b border-slate-700 pb-2" data-id="element-40">
              <span data-id="element-41">5 Módulos Maestros completos</span>
              <span className="font-bold" data-id="element-42">$49.900</span>
            </div>
            <div className="flex justify-between text-lg md:text-xl text-gray-300 border-b border-slate-700 pb-2" data-id="element-43">
              <span data-id="element-44">Clases grabadas paso a paso</span>
              <span className="font-bold" data-id="element-45">$15.000</span>
            </div>
            <div className="flex justify-between text-lg md:text-xl text-gray-300 border-b border-slate-700 pb-2" data-id="element-46">
              <span data-id="element-47">4 Bonos exclusivos</span>
              <span className="font-bold" data-id="element-48">$34.970</span>
            </div>
            <div className="pt-4 flex justify-between text-2xl font-black text-white" data-id="element-49">
              <span data-id="element-50">VALOR TOTAL</span>
              <span className="line-through text-gray-500" data-id="element-51">$99.870</span>
            </div>
          </div>

          <div className="text-center bg-brand-primary/10 rounded-2xl p-6 border border-brand-primary/30" data-id="element-52">
            <p className="text-xl text-brand-secondary font-bold mb-2" data-id="element-53">
              HOY PAGÁS SOLO
            </p>
            <p className="text-5xl md:text-6xl font-black text-white mb-6" data-id="element-54">
              $19.990
            </p>
            <div className="space-y-2 text-lg font-medium text-brand-ice" data-id="element-55">
              <p data-id="element-56">Menos del 20% del valor real.</p>
              <p className="font-bold text-brand-amber" data-id="element-57">
                El primer trabajo que hacés recupera la inversión completa.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}